import { defineComponent as m, createBlock as p, openBlock as i, resolveDynamicComponent as t, withCtx as r, unref as n, mergeProps as c, renderSlot as d } from "vue";
import h from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Masthead/masthead.js";
import u from "../../helpers/PassThrough.vue2.js";
import { useOUIAProps as B } from "../../helpers/ouia.js";
const I = /* @__PURE__ */ m({
  name: "PfMastheadBrand",
  inheritAttrs: !1,
  __name: "MastheadBrand",
  props: {
    component: {},
    href: {},
    to: {},
    replace: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(f) {
    const o = f, l = B({ id: o.ouiaId, safe: o.ouiaSafe }), s = o.component ?? ((o.href ?? o.to) === void 0 ? "span" : "a");
    return (e, k) => (i(), p(t(e.to ? "router-link" : u), {
      to: e.to,
      replace: e.replace,
      custom: ""
    }, {
      default: r((a) => [
        (i(), p(t(n(s)), c({ ...n(l), ...e.$attrs }, {
          class: n(h).mastheadBrand,
          tabindex: n(s) === "a" ? 0 : void 0,
          href: (a == null ? void 0 : a.href) ?? e.href,
          onClick: a == null ? void 0 : a.navigate
        }), {
          default: r(() => [
            d(e.$slots, "default")
          ]),
          _: 2
        }, 1040, ["class", "tabindex", "href", "onClick"]))
      ]),
      _: 3
    }, 8, ["to", "replace"]));
  }
});
export {
  I as default
};
